export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00429.06b0cca1.png";